import { render, staticRenderFns } from "./HeroCard.vue?vue&type=template&id=0073fb09&scoped=true&"
import script from "./HeroCard.vue?vue&type=script&lang=js&"
export * from "./HeroCard.vue?vue&type=script&lang=js&"
import style0 from "./HeroCard.vue?vue&type=style&index=0&id=0073fb09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0073fb09",
  null
  
)

export default component.exports